import { ReactComponent as EditIcon } from "assets/edit.svg";
import { ReactComponent as ExpandIcon } from "assets/expand.svg";

import styles from "./SavedRoutes.module.scss";
import { date2usDotDate } from "helpers";
import React from "react";
import Button from "components/Button/Button";
import { store } from "stores/Store";
import useExternalApiService from "helpers/ExternalApiService";
import { ReactComponent as  MagnifyingGlassIcon } from 'assets/magnifyingGlass.svg';

interface ISavedRoutes {
  onRouteCardClicked?: (route: any) => void;
}

const SavedRoutes = ({ onRouteCardClicked }: ISavedRoutes) => {
  const [editMode, setEditMode] = React.useState(false);
  const [routes, setRoutes] = React.useState([]);
  const [selectedRoutes, setSelectedRoutes] = React.useState<number[]>([]);

  const [searchTerm, setSearchTerm] = React.useState('');
  const apiUrl = process.env.REACT_APP_EAI_URL;
  const { postData } = useExternalApiService(apiUrl);

  React.useEffect(() => {
    fetchRoutes();
  }, []);

  React.useEffect(() => {
    fetchRoutes();
  }, [store.impersonatedUser]);

  const toggleRouteSelection = (routeId: number) => {
    if(selectedRoutes.includes(routeId)) {
      setSelectedRoutes(selectedRoutes.filter(id => id !== routeId));
    } else {
      setSelectedRoutes([...selectedRoutes, routeId]);
    }
  }

  const fetchRoutes = async () => {
    const data = await postData('/api/get_routes_for_chat', {"fmc_email": store.impersonatedUser});
    setRoutes(data.routes);
  };

  const onDelete = () => {
    setRoutes(routes.filter((route: any) => !selectedRoutes.includes(route.id)));
    setSelectedRoutes([]);
    setEditMode(false);
    deleteRoutes();
  }

  const deleteRoutes = async () => {
    await postData('/api/delete_routes', {"fmc_email": store.impersonatedUser, "route_ids": selectedRoutes.map((id: number) => id.toString())});
  }

  const renderRouterCards = (onRouteCardClicked: (routeId: number) => void) => {
    let filteredRoutes = routes;
    if (searchTerm) {
      const searchLower = searchTerm.toLowerCase();
      filteredRoutes = routes.filter((p: any) => 
        p?.name.toLowerCase().includes(searchLower) 
      );
    }
    return filteredRoutes.map((routerCard: any, index: number) => {
      if(editMode) {
        return (
          <div 
            onClick={() => {toggleRouteSelection(routerCard.id)}}
            className={`${styles.routerCardEdit} ${selectedRoutes.includes(routerCard.id) ? styles.routerCardEditSelected : ''} ${index === 0 ? styles.firstRouterCard : ''}`} key={routerCard.id}>
            <div className={`${styles.radioDiv} ${selectedRoutes.includes(routerCard.id) ? styles.radioDivSelected : ''}`} />
            <div>
              <p className={styles.routerCardHeader}> {`${index + 1}. ${routerCard.name}`}</p>
              <p className={styles.text}>Created at {date2usDotDate(routerCard?.created_at)}</p>
              <p className={styles.fmcName}>{`${routerCard.practitioner_ids.length} Waypoints`}</p>
            </div>
          </div>
        )  
      } else {
        return (
          <div 
            onClick={() => {onRouteCardClicked(routerCard.id)}}
            className={`${styles.routerCard} ${index === 0 ? styles.firstRouterCard : ''}`}
            key={routerCard.id}
          >
            <div>
              <p className={styles.routerCardHeader}> {`${index + 1}. ${routerCard.name}`}</p>
              <p className={styles.text}>Created at {date2usDotDate(routerCard?.created_at)}</p>
              {routerCard?.route_date && (
                <p className={styles.text}>Route date: {date2usDotDate(routerCard?.route_date)}</p>
              )}
              <p className={styles.fmcName}>{`${routerCard?.route_length} Waypoints`}</p>
            </div>
            <ExpandIcon />
          </div>
        )  
      }
    })
  }
  
  const renderHeader = () => {
    if(editMode) {
      return (
        <div className={styles.headerWrapper}>
          <p className={styles.headerText}>{selectedRoutes.length} Routes Selected</p>
          <div className={styles.headerButtons}>
            <Button type="outline" onClick={() => {setEditMode(false)}} >CANCEL</Button>
            <Button type="outline" textColor="#E64B37" color="#E64B3780" onClick={onDelete}>DELETE</Button>
          </div>
        </div>
      )
    } else {
      return (
        <div className={styles.headerWrapper}>
          <p className={styles.headerText}>You have a total of <b>{routes.length} routes</b></p>
          <EditIcon onClick={() => {setEditMode(!editMode)}} width={20} height={20}/>
        </div>
      )
    }
  }

  const renderSearch = () => {
    return (
      <div className={styles.searchWrapper}>
      <MagnifyingGlassIcon width={20} height={20} />        
      <input
        type="text"
        placeholder="Search"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className={styles.searchInput}
      />
      {searchTerm && (
        <button 
          className={styles.clearButton}
          onClick={() => setSearchTerm('')}
        >
          X
        </button>
      )}
    </div>
    )
  }
  return(
    <div className={styles.container}>
      {renderHeader()}
      {renderSearch()}
      <div className={styles.scrollableContent}>
        {renderRouterCards(onRouteCardClicked || (() => {}))}
      </div>
    </div>
  )
}

export default SavedRoutes;